export enum KillSwitchNames {
  DISRUPTION_SELF_SERVE_REBOOK = "DisruptionSelfServeRebook",
}
